import { useAppSelector } from '@redux/hooks';
import { FormRecordPhone } from './FormRecordPhone';
import { Grid } from '@ui-kit/Grid';
import { MyLink } from '@ui-kit/Link';
import classNames from 'classnames';

import styles from './PopupRecordPhone.module.scss';

export const PopupRecordPhone = (): JSX.Element => {
  const { PHONE, FEDERAL_PHONE } = useAppSelector(state => state.header.data?.region);
  return (
    <Grid column gap={'10px'} className={styles.Container}>
      <Grid column gap={'10px'} className={styles.WrapperPhone}>
        <p>Позвонить:</p>
        <Grid column gap={'10px'} className={styles.BoxPhone}>
          {PHONE && (
            <MyLink className={styles.ContainerPhone} href={`tel:${PHONE}`}>
              <div className={classNames(styles.Phone, 'second-local-phone')}>{PHONE}</div>
            </MyLink>
          )}
          {FEDERAL_PHONE && (
            <MyLink className={classNames(styles.ContainerPhone, styles.Free)} href={`tel:${FEDERAL_PHONE}`}>
              <Grid gap={'5px'}>
                <div className={classNames(styles.Phone, 'federal-phone')}>{FEDERAL_PHONE} </div>
                <div className={styles.Text}>бесплатный звонок</div>
              </Grid>
            </MyLink>
          )}
        </Grid>
      </Grid>
      <FormRecordPhone />
    </Grid>
  );
};
